import { HSVtoRGB, RGBToHex, isHex } from "./helpers/color";
import { el } from "@dhx/ts-common/dom";
import locale from "./locales/en";
import { IPickerState } from "./types";
import { Colorpicker } from "./Colorpicker";

export function getPicker(colorpicker: Colorpicker, pickerState: IPickerState, handlers: any) {
	const rgb = HSVtoRGB(pickerState.hsv);
	pickerState.background = RGBToHex(rgb);

	const currentBackground = RGBToHex(HSVtoRGB({ h: pickerState.hsv.h, s: 1, v: 1 }));
	const root = colorpicker.getRootView();
	const box = root.refs
		? root.refs.picker_palette.el.getBoundingClientRect()
		: { height: 200, width: 218, x: 0, y: 0 };

	const height = box.height - 2;
	const width = box.width - 2;

	const gripTop = height - pickerState.hsv.v * height - 4;
	const gripLeft = pickerState.hsv.s * width - 4;

	const rangeWidth = box.width - 6;
	const rangeGripLeft = rangeWidth - ((360 - pickerState.hsv.h) / 360) * rangeWidth;

	const inputValue = isHex(pickerState.customHex)
		? pickerState.customHex.replace("#", "")
		: pickerState.background.replace("#", "");

	return el(".dhx_colorpicker-picker", {}, [
		el(
			".dhx_colorpicker-picker__palette",
			{
				style: {
					height: 132,
					background: currentBackground,
				},
				onmousedown: handlers.mousedown,
				ontouchstart: handlers.touchstart,
				"data-dhx-id": "picker_palette",
				_ref: "picker_palette",
			},
			[
				el(".dhx_palette_grip", {
					style: {
						top: gripTop,
						left: gripLeft,
					},
					tabindex: 0,
				}),
			]
		),
		el(
			".dhx_colorpicker-hue-range",
			{
				style: { height: 16 },
				onmousedown: handlers.mousedown,
				ontouchstart: handlers.touchstart,
				"data-dhx-id": "hue_range",
				_key: "hue_range",
				_ref: "hue_range",
			},
			[
				el(".dhx_colorpicker-hue-range__grip", {
					style: { left: rangeGripLeft },
					tabindex: 0,
				}),
			]
		),
		el(".dhx_colorpicker-value", [
			el(".dhx_colorpicker-value__color", {
				style: { background: pickerState.background },
			}),
			el(".dhx_colorpicker-value__input__wrapper", [
				el("input", {
					class: "dhx_colorpicker-value__input",
					value: inputValue,
					oninput: handlers.oninput,
					maxlength: "7",
					_key: "hex_input",
					"aria-label": "type color in HEX format",
				}),
			]),
		]),
		el(".dhx_colorpicker-picker__buttons", [
			!colorpicker.config.pickerOnly &&
				el(
					"button",
					{
						class:
							"dhx_button dhx_button--size_medium dhx_button--view_link dhx_button--color_primary",
						onclick: [handlers.buttonsClick, "cancel"],
					},
					locale.cancel
				),
			el(
				"button",
				{
					class:
						"dhx_button dhx_button--size_medium dhx_button--view_flat dhx_button--color_primary",
					onclick: [handlers.buttonsClick, "apply"],
				},
				locale.select
			),
		]),
	]);
}

export function calculatePaletteGrip(rootView: any, top: number, left: number) {
	const paletteRect = rootView.refs.picker_palette.el.getBoundingClientRect();
	const bottom = paletteRect.height;
	const right = paletteRect.width;

	top = top < 0 ? 0 : top > bottom ? bottom : top;
	left = left < 0 ? 0 : left > right ? right : left;

	const pLeft = Math.round(left / (right / 100));
	const pTop = 100 - Math.round(top / (bottom / 100));

	this._pickerState.hsv.s = pLeft / 100;
	this._pickerState.hsv.v = pTop / 100;
}
